<template>
  <div>
    <div v-for="item in mubanObj.htmlStyleList" :key="item.id">
      <!-- 视频 -->
      <video
        v-if="item.label == 'video'"
        autoplay
        :class="item.className"
        width="100%"
        :src="
          attributeObj.schoolPageInfo[item.attribute]
            ? attributeObj.schoolPageInfo[item.attribute]
            : videoUrl
        "
        :style="item.style"
      ></video>
      <!-- 图片 -->
      <el-image
        v-if="item.label == 'image'"
        :class="item.className"
        :src="
          attributeObj.schoolPageInfo[item.attribute]
            ? attributeObj.schoolPageInfo[item.attribute]
            : defaultPic
        "
        fit="cover"
        :style="item.style"
      ></el-image>
      <!-- 文本 -->
      <div
        v-if="item.label == 'div'"
        :class="item.className"
        :style="item.style"
        v-html="
          item.attribute == 'custom'
            ? item.custom
            : attributeObj.schoolPageInfo[item.attribute]
        "
      ></div>
      <!-- 矢量图 -->
      <div
        v-if="item.label == 'icon'"
        class="yh-iconfont"
        :style="item.style"
        :class="[item.icon, item.className]"
      ></div>
      <!-- 评分 -->
      <div v-if="item.label == 'rate'" :style="item.style" :class="item.className">
        <el-rate
          :value="attributeObj.schoolPageInfo[item.attribute] || 0"
          disabled
          :colors="['#E33900', '#E33900', '#E33900']"
        >
        </el-rate>
      </div>
      <!-- 列表 -->
      <div
        class="flexList"
        :style="item.style"
        v-if="item.label == 'list'"
        :class="item.className"
      >
        <div
          v-for="(Item, _index) in attributeObj.schoolPageInfo[item.attribute]"
          :key="_index"
        >
          <div
            :class="item.htmlStyleList[0].className"
            :style="item.htmlStyleList[0].style"
            v-if="item.htmlStyleList[0].label == 'div'"
          >
            {{ Item }}
          </div>
          <el-image
            :src="Item"
            fit="cover"
            :class="item.htmlStyleList[0].className"
            :style="item.htmlStyleList[0].style"
            v-if="item.htmlStyleList[0].label == 'image'"
          ></el-image>
        </div>
      </div>
      <el-row v-if="item.label == 'row'" :style="item.style" :class="item.className">
        <span>
          <el-col :span="Item.col" v-for="Item in item.htmlStyleList" :key="Item.id">
            <video
              :key="Item.id"
              :style="Item.style"
              :class="Item.className"
              v-if="Item.label == 'video'"
              :src="
                attributeObj.schoolPageInfo[Item.attribute]
                  ? attributeObj.schoolPageInfo[Item.attribute]
                  : videoUrl
              "
              autoplay
              width="100%"
            ></video>
            <el-image
              :key="Item.id"
              :style="Item.style"
              :class="Item.className"
              v-if="Item.label == 'image'"
              :src="
                attributeObj.schoolPageInfo[Item.attribute]
                  ? attributeObj.schoolPageInfo[Item.attribute]
                  : defaultPic
              "
              fit="cover"
            ></el-image>
            <div
              v-if="Item.label == 'div'"
              :style="Item.style"
              :key="Item.id"
              :class="Item.className"
              v-html="
                Item.attribute == 'custom'
                  ? Item.custom
                  : attributeObj.schoolPageInfo[Item.attribute]
              "
            ></div>
            <div
              v-if="Item.label == 'icon'"
              class="yh-iconfont"
              :style="Item.style"
              :class="[Item.icon, Item.className]"
            ></div>
            <div v-if="Item.label == 'rate'" :style="Item.style" :class="Item.className">
              <el-rate
                :value="attributeObj.schoolPageInfo[Item.attribute] || 0"
                disabled
                :colors="['#E33900', '#E33900', '#E33900']"
              >
              </el-rate>
            </div>
          </el-col>
        </span>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    attributeObj: Object,
    mubanObj: Object,
  },
  data() {
    return {
      videoUrl:
        "http://1251150518.vod2.myqcloud.com/8d224e9cvodgzp1251150518/a775f1ae3701925920751120030/4RPCJ58Vki4A.mp4",
      defaultPic:
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
    };
  },
};
</script>
<style scoped>
.active {
  color: rgb(64, 79, 212) !important;
}
.flexList {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/onlineSchool/template/mubanTemplateOne.vue